import { Navigate } from "react-router-dom";
import LoadingPage from "../utils/loading.page";
import { useStripeStore } from "@/stores/stripe.store";
import { useEffect } from "react";

export function StripeCallbackPage() {
  const { stripeSnapshot, stripeProxy } = useStripeStore();

  useEffect(() => {
    stripeProxy.confirmCheckout();
  }, []);

  if (!stripeSnapshot.isLoading) {
    return <Navigate to={stripeSnapshot.previousPage} />;
  }

  return <LoadingPage />;
}

export default StripeCallbackPage;
